module.exports = __webpack_public_path__ + "static/media/logo.7e64ea8c.png";